import styled from "styled-components";

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  margin: 0 235px 0 235px;
  padding: 18px 0;
  ${'' /* background-color: #FAFAFA; */}
  justify-content: space-between;
  align-items: center;
  @media (max-width: 1000px) {
    margin: 0 30px;
  }
`;

// export const Heading = styled.h1`
//   margin: 0;
//   font-family: NunitoSans-Bold;
//   font-style: normal;
//   font-weight: 700;
//   font-size: 48px;
//   line-height: 65.47px;
//   letter-spacing: 1.5px;

//   /* black */

//   color: #000000;
// `;

export const Heading = styled.h1`
margin: 0;
  font-family: NunitoSans-Bold;
  font-style: normal;
  font-weight: 700;
  font-size: 30px;
  line-height: 65.47px;
  letter-spacing: 1.5px;

  /* grey */

  color: #000000;
  @media (max-width: 600px) {
    font-size: 24px;
    line-height: 33px;
  }
`;

export const Line = styled.div`
  width:  100px;
  height: 3px;
  background-size: cover;
  background-image: url("/images/icons/Rectangle 36.png");
`;

export const SubHeading = styled.h2`
  margin: 0;
  font-family: NunitoSans-SemiBold;
  font-style: normal;
  font-weight: 600;
  font-size: 20px;
  line-height: 30px;
  letter-spacing: 0.5px;

  /* secondary Dark */

  color: #d67723;
`;

export const InfoContainer = styled.h1`
  display: flex;
  margin: 0 84px 0 122px;
  height: 64px;
  padding: 18px 0;
  justify-content: space-evenly;
  aliten-items: center;
  flex-direction: row;
`;

export const Logo = styled.img`
  width: 23%;
  padding: 7px;
  padding-bottom: 20px;
  height: 85.27px;
  object-fit: contain;
`;

export const Frame = styled.div`
  display: flex;
  flex-wrap: wrap;
  padding: 20px;
  justify-content: space-evenly;
`;
